<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">
        <i class="fa-solid fa-user-tie me-2"></i>
        <ng-container *ngIf="viewMode == ViewMode.INSERT">Kunde anlegen</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.EDIT">Kunde bearbeiten</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.VIEW">Kunde</ng-container>
    </h1>
</div>

<form [formGroup]="form">

    <div class="row">
        <div class="col">
            <label>Nummer</label>
            <input type="text" class="form-control" formControlName="number" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.number }}</p>
        </div>
        <div class="col" *ngIf="viewMode == ViewMode.VIEW">
            <label>Erstellt am</label>
            <p>{{ form.value.created_at | date: 'dd.MM.yyyy HH:mm' }}</p>
        </div>
        <div class="col">
            <label>Aktualisiert am</label>
            <p>{{ form.value.updated_at | date: 'dd.MM.yyyy HH:mm'}}</p>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <label>Nachname</label>
            <input type="text" class="form-control" formControlName="lastname" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.lastname }}</p>
        </div>
        <div class="col-4">
            <label>Vorname</label>
            <input type="text" class="form-control" formControlName="firstname" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.firstname }}</p>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <label>Nachname 2</label>
            <input type="text" class="form-control" formControlName="lastname_2" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.lastname_2 }}</p>
        </div>
        <div class="col-4">
            <label>Nachname 3</label>
            <input type="text" class="form-control" formControlName="lastname_3" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.lastname_3 }}</p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>PLZ</label>
            <input type="text" class="form-control" formControlName="zip" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.zip }}</p>
        </div>
        <div class="col">
            <label>Ort</label>
            <input type="text" class="form-control" formControlName="city" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.city }}</p>
        </div>
        <div class="col">
            <label>Straße</label>
            <input type="text" class="form-control" formControlName="street" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.street }}</p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Telefon</label>
            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.phone }}</p>
        </div>
        <div class="col">
            <label>Mobil-Nummer</label>
            <input type="text" class="form-control" formControlName="phone_mobile" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.phone_mobile }}</p>
        </div>
        <div class="col">
            <label>Privat-Nummer</label>
            <input type="text" class="form-control" formControlName="phone_private" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.phone_private }}</p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>E-Mail</label>
            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW"><a [href]="'mailto:' + form.value.email">{{ form.value.email }}</a></p>
        </div>
        <div class="col">
            <label>E-Mail 2</label>
            <input type="text" class="form-control" formControlName="email_2" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW"><a [href]="'mailto:' + form.value.email_2">{{ form.value.email_2 }}</a></p>
            <p></p>
        </div>
        <div class="col">
            <label>Bonität</label>
            <input type="number" class="form-control" formControlName="credit_rating" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.credit_rating }}</p>
        </div>
    </div>
</form>

<div class="row">
    <div class="col">
        <label>Kontakte</label>

        <div>
            <button type="button" class="btn btn-primary" (click)="addContact()" *ngIf="!newContact && viewMode != ViewMode.VIEW">Kontakt anlegen</button>
            <button type="button" class="btn btn-primary ms-2" (click)="showContacts()" *ngIf="!newContact && !showAssignContacts && viewMode != ViewMode.VIEW">Bestehenden Kontakt zuweisen</button>
        </div>

        <div class="input-group my-3" *ngIf="showAssignContacts && viewMode != ViewMode.VIEW">
            <select class="form-control" name="contacts" [(ngModel)]="contactToAssign">
                <option value="null" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let contact of unassignedContacts" [ngValue]="contact">
                    {{ contact.name }}
                </option>
            </select>
            <button class="btn btn-outline-success" type="button" [disabled]="contactToAssign == null" (click)="assignContact()">Zuweisen</button>
            <button class="btn btn-outline-secondary" type="button" (click)="cancelShowContacts()">Abbrechen</button>
        </div>

        <div class="table-responsive">
            <table class="table table-sm table-striped table-hover bg-white pointer">
                <thead>
                <tr>
                    <th style="width: 100px" *ngIf="viewMode != ViewMode.VIEW"></th>
                    <th>Name</th>
                    <th>PLZ</th>
                    <th>Ort</th>
                    <th>Straße</th>
                    <th>Telefon</th>
                    <th>E-Mail</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="newContact">
                    <td>
                        <button type="button" class="btn btn-primary btn-sm" (click)="confirmAddContact()" [disabled]="!newContact.name"><i class="fa-solid fa-check fa-fw"></i></button>
                        <button type="button" class="btn btn-danger btn-sm ms-2" (click)="cancelAddContact()"><i class="fa-solid fa-times fa-fw"></i></button>
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_name" [(ngModel)]="newContact.name" required>
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_zip" [(ngModel)]="newContact.zip">
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_city" [(ngModel)]="newContact.city">
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_street" [(ngModel)]="newContact.street">
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_phone" [(ngModel)]="newContact.phone">
                    </td>
                    <td>
                        <input type="text" class="form-control" name="contact_mail" [(ngModel)]="newContact.mail">
                    </td>
                </tr>
                <ng-container *ngFor="let contact of contacts; let i = index">
                    <tr *ngIf="!contact._deleted">
                        <td *ngIf="viewMode != ViewMode.VIEW">
                            <ng-container *ngIf="contact._editing">
                                <button type="button" class="btn btn-primary btn-sm" (click)="confirmEditContact(contact)" [disabled]="!contact.name || !contact.phone || !contact.mail"><i class="fa-solid fa-check fa-fw"></i></button>
                                <button type="button" class="btn btn-danger btn-sm ms-2" (click)="cancelEditContact(contact)"><i class="fa-solid fa-times fa-fw"></i></button>
                            </ng-container>
                            <ng-container *ngIf="!contact._editing">
                                <button type="button" class="btn btn-primary btn-sm" (click)="editContact(contact)"><i class="fa-solid fa-pencil fa-fw"></i></button>
                                <button type="button" class="btn btn-danger btn-sm ms-2" (click)="deleteContact(contact)"><i class="fa-solid fa-trash fa-fw"></i></button>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.name }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_name_' + i" [(ngModel)]="contact.name" required>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.zip }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_zip_' + i" [(ngModel)]="contact.zip">
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.city }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_city_' + i" [(ngModel)]="contact.city">
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.street }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_street_' + i" [(ngModel)]="contact.street">
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.phone }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_phone_' + i" [(ngModel)]="contact.phone">
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="!contact._editing">{{ contact.mail }}</ng-container>
                            <ng-container *ngIf="contact._editing">
                                <input type="text" class="form-control" [name]="'contact_mail_' + i" [(ngModel)]="contact.mail">
                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
                </tbody>
            </table>

            <p class="text-muted" *ngIf="hasNoContacts()">Keine Kontakte hinzugefügt</p>
        </div>
    </div>
</div>

<div style="border-top: 1px solid #dee2e6" class="my-3 pt-3">
    <ng-container *ngIf="viewMode == ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
        <!--<button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>-->
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid || editingContacts() || newContact != null" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid || editingContacts() || newContact != null" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>

<ng-container *ngIf="id_customer != '0'">
    <h3 class="h4">Aufgaben</h3>

    <button type="button" class="btn btn-primary mb-3" (click)="createTask()">Aufgabe anlegen</button>

    <pagination
            [hidden]="entries?.length == 0"
            [totalItems]="totalEntries"
            [itemsPerPage]="paginConfig.itemsPerPage"
            [(ngModel)]="paginConfig.page"
            (pageChanged)="listEntries($event)"
            [maxSize]="20"
            previousText="Letzte"
            nextText="Nächste">
    </pagination>

    <div class="table-responsive">
        <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
            <thead>
            <tr>
                <th (click)="setOrder('title')">
                    Titel <i class="fas" *ngIf="predicate == 'title'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                </th>
                <th>Status</th>
                <th (click)="setOrder('created_at')">
                    Erstellt am <i class="fas" *ngIf="predicate == 'created_at'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                </th>
                <th (click)="setOrder('due_date')">
                    Fälligkeit <i class="fas" *ngIf="predicate == 'due_date'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                </th>
                <th (click)="setOrder('department')">
                    Abteilung <i class="fas" *ngIf="predicate == 'department'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let entry of entries" [routerLink]="['/task', entry.id]">
                <td>{{ entry.title }}</td>
                <td>
                    <i class="fa-solid fa-circle"
                       [class.text-danger]="entry.status == 'new'"
                       [class.text-warning]="entry.status == 'in_progress'"
                       [class.text-success]="entry.status == 'done'"
                       [class.text-secondary]="entry.status == 'cancelled'"
                    ></i>
                    {{ entry.status | status }}
                </td>
                <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}</td>
                <td>
                    <i class="fa fa-exclamation-triangle text-danger" *ngIf="entry.due_date_past"></i>
                    {{ entry.due_date | date: 'dd.MM.yyyy' }}
                </td>
                <td>
                    {{ entry.department }}
                    <span class="text-muted" *ngIf="!entry.department">Nicht gesetzt</span>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="text-muted" *ngIf="entries?.length == 0">Noch keine Aufgaben</div>
    </div>
</ng-container>
